import { Link } from "react-router-dom";

const Item = (props) => {

  console.log(props)

  return (
    <article key={props.id} className="producto">
      <Link to={`/producto/${props.id}/${props.tipo}`} className="link-ajuste-item">
        <div className="link-ajuste"> 
        <img alt="" className="imagen-empanada-item" src={props.img} />
        <div className="nombre-precio">
          <div>
            <h3 className="nombre">{props.nombre}</h3>
            <p className="ingredientes">{props.ingredientes}</p>
          </div>
          <span className="precio">${props.precio}</span>
        </div>
        </div>
        <div className="plus-cont">
          <i className="fa fa-plus-square-o plus-icon" aria-hidden="true"></i>
          
        </div>

      </Link>
    </article>
  )
};
/*
  <article key={props.id} className="producto">
      <Link to={`/producto/${props.id}`} className="link-ajuste">
        <div className="nombre-precio">
          <div>
            <span className="nombre">{props.nombre}</span>
            <p className="ingredientes">{props.ingredientes}</p>
          </div>

          <span className="precio">${props.precio}</span>
        </div>
        <img alt="" className="imagen-empanada-inicial" src={props.img} />
      </Link>
    </article>*/
export default Item